import { configWithAuth, configWithoutAuth } from '../helpers'
import { makeGetRequest } from '../helpers/api'

export const metadataService = {
    getMetadata: () => makeGetRequest('admin/metadata', configWithAuth()),
}
